/**
 * Work Plan & Execution Dashboard
 * 
 * Unified dashboard for proposal execution and delivery:
 * - Work Plans: Manage project work breakdown
 * - Technical Approaches: Define methodologies
 * - Compliance: Track compliance requirements
 * 
 * Now uses WorkplanReports component (similar to ComplianceReports for proposals)
 */

import React from 'react';
import { ListChecks } from 'lucide-react';
import { WorkplanReports } from '../components/WorkplanReports';

export function WorkPlanExecutionDashboard() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold flex items-center gap-3">
          <ListChecks className="h-8 w-8 text-green-600" />
          Work Plan & Execution
        </h1>
        <p className="text-gray-600 mt-1">
          Manage work plans, search workplans and related entities, create new workplans, and manage canonical data
        </p>
      </div>
      
      {/* Main WorkplanReports Component */}
      <WorkplanReports />
    </div>
  );
}

